import React, { Suspense } from 'react';
import { FC } from 'react';
import { UserContextProvider } from './system/providers/userContextProvider';
import AppContextProvider, { AppContext } from './system/providers/appContextProvider';
import AuthContextProvider, { AuthContext } from './system/providers/authProvider';
import renderGlobalAlert from './system/hooks/useGlobalAlert';
import 'fontsource-roboto'
import "./App.module.scss"
import { TabsProvider } from './system/providers/tabsProvider';
import { PluginProvider } from './system/providers/plugin';
import jwtDecode from 'jwt-decode';
import { TestApiProvider } from './system/providers/testApiProvider';
import { BarcodeReaderGlobal } from './system/providers/barcodeReaderGlobal';
import usePreventDeveloperMode from './system/hooks/usePreventDeveloperMode';
import { UpgradePatchAction } from './components/upgradePatchAction/UpgradePatchAction';
import axios from 'axios';
import { envF } from "../src/env";
import { useTranslation } from 'react-i18next';
import { SystemSettingsProvider } from './system/providers/systemSettingsProvider';
import moment from "moment-timezone";
import "moment/locale/ru";
import CustomConfigProvider from './libs/corporate/theme/antdTheme';
import { AlertsProvider } from './system/providers/plugin';
import { IErrorMessage, IExceptionMessage } from './libs/fetchApiDistributor/common';
import { useFixCapsLock } from './system/hooks/useFixCapsLock';
import { TourProvider } from './components/tour/TourContext';

const HomePage = React.lazy(() => import('./pages/homePage'));
const LoginPage = React.lazy(() => import('./pages/loginPage'));

moment.locale("ru");
window.onbeforeunload = function (e: any) {
    try
    {
        localStorage.removeItem('openedTabsWithSelections');
    }
    catch(err)
    {
        console.error(err)
    }

  logout();
};

const logout = () => {
    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const headers = {
        headers: {
            Authorization: token,
        },
    };

    axios.get(`${envF.REACT_APP_OAUTH_API_PATH}/` + "auth/logout", headers).then((e) => {
        console.info("Logout success");
    });    
};

const App: FC = (props) => {
    usePreventDeveloperMode();
    useFixCapsLock(); 

    const { t } = useTranslation();    
    function StartApp() {
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <AlertsProvider>
                    <CustomConfigProvider>
                        <AppContextProvider>
                            <AppContext.Consumer>
                                {(appCtx) => {
                                    return (
                                        <TestApiProvider>
                                            <AuthContextProvider>
                                                <AuthContext.Consumer>
                                                    {(authCtx) => {
                                                        if (authCtx.userIsAuth) {
                                                            const token = JSON.parse(localStorage.getItem("TokenData") as string).payload.name;
                                                            return (
                                                                <>
                                                                    {authCtx.updateStart && (
                                                                        <UpgradePatchAction title={token !== "admin" ? "Идёт обновление" : ""} stopUpdateButton={token === "admin" ? true : false} />
                                                                    )}
                                                                    <UserContextProvider>
                                                                        <TabsProvider>
                                                                            <SystemSettingsProvider>
                                                                                <BarcodeReaderGlobal>
                                                                                    <PluginProvider>
                                                                                        <TourProvider>
                                                                                            <HomePage                                                                                        
                                                                                                logout={() => {
                                                                                                    Promise.resolve().then(() => {
                                                                                                        const jwtToken = localStorage.getItem("TokenData") as string;
                                                                                                        const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
                                                                                                        const headers = {
                                                                                                            headers: {
                                                                                                                Authorization: token,
                                                                                                            },
                                                                                                        };
                                                                                                        
                                                                                                        // Очистить кэш вызовов отчётов
                                                                                                        appCtx.reportAPIService.reportRequest.then((r) => {
                                                                                                            r.freeForUser(headers);
                                                                                                            authCtx.logout(headers);
                                                                                                            authCtx.unauthorize();
                                                                                                        });
                                                                                                    });
                                                                                                }}
                                                                                            ></HomePage>
                                                                                        </TourProvider>
                                                                                    </PluginProvider>
                                                                                </BarcodeReaderGlobal>
                                                                            </SystemSettingsProvider>
                                                                        </TabsProvider>
                                                                    </UserContextProvider>
                                                                </>
                                                            );
                                                        } else {
                                                            return (
                                                                <LoginPage
                                                                    loginOnClick={(u, p, ec) => {
                                                                        appCtx.coreApiService?.accessTokenRequest.getAccessToken(u, p, (resp) => {
                                                                            if (resp.respType === "isCompleted") {
                                                                                const decoded: DecodedToken = jwtDecode(resp.data.access_token);
                                                                                authCtx.authorize({
                                                                                    accessToken: resp.data.access_token,
                                                                                    refreshToken: resp.data.refresh_token,
                                                                                    payload: {
                                                                                        idGlobal: decoded.sub,
                                                                                        name: decoded.preferred_username,
                                                                                    },
                                                                                });
                                                                            } else {
                                                                                const statusCode: number = resp.message?.statusCode ?? 0;
                                                                                const detailScope: IErrorMessage | IExceptionMessage = resp.message;
                                                                                const isLicenseValidationDetails = detailScope.detail && detailScope.detail.includes("ActiveSessionTokenValidator");

                                                                                const getTitle = () => {
                                                                                    let title = t("login.auth.errors.basic"); //"Ошибка авторизации"
                                                                                    const message = (detailScope as IExceptionMessage).message;

                                                                                    if (statusCode === 400) {
                                                                                        if (message && message.length > 0) {
                                                                                            title = message;
                                                                                        } else {
                                                                                            title = t("login.auth.errors.invalidLogin"); // "Неправильные учётные данные"
                                                                                        }
                                                                                    } else if (statusCode === 401 && isLicenseValidationDetails) {

                                                                                        //"Ошибка подключения по лицензии"
                                                                                        if (message && message.length > 0) {
                                                                                            title = message;
                                                                                        } else {
                                                                                            title = t("login.auth.errors.badLicense");
                                                                                        }
                                                                                    }

                                                                                    return title;
                                                                                };

                                                                                renderGlobalAlert({
                                                                                    variant: resp.message.type,
                                                                                    statusCode: resp.message?.statusCode ?? 500,
                                                                                    title: getTitle(),
                                                                                    detail: "",
                                                                                    instance: t("login.auth.instance"), //"Авторизация"
                                                                                });
                                                                                ec();
                                                                            }
                                                                        });
                                                                    }}
                                                                ></LoginPage>
                                                            );
                                                        }
                                                    }}
                                                </AuthContext.Consumer>
                                            </AuthContextProvider>
                                        </TestApiProvider>
                                    );
                                }}
                            </AppContext.Consumer>
                        </AppContextProvider>
                    </CustomConfigProvider>
                </AlertsProvider>            
            </Suspense>    
        );
    }
    return StartApp();
};

export default App;
